import MicroModal from "micromodal";

const TentSelector = () => {
  const links = document.querySelectorAll('a[href*="#tent-selector"]');
  document.addEventListener('DOMContentLoaded', () => {
    MicroModal.init({
      disableScroll: true,
      debugMode: false,
    });
  });

  for (const link of links) {
    link.addEventListener('click', (evt) => {
      evt.preventDefault();
      // console.log('Link clicked!');
      const scriptElement = document.createElement('script');
      scriptElement.src = theme.routes.zoovuSrc;
      scriptElement.setAttribute('defer', true);
      document.head.appendChild(scriptElement);
      scriptElement.onload = () => {
        // console.log('Script loaded!');
        MicroModal.show('perfect-tent-modal');
      };
    });
  }
};

TentSelector();

export default TentSelector;
